import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@/components/ui/skeleton";
export function TodoSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-2">{[...Array(5)].map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, i) {
  return <div key={i} className="flex items-center px-4 py-2.5 gap-3"><Skeleton className="h-[18px] w-[18px] rounded-[4px]" /><Skeleton className="h-5 flex-1" /><Skeleton className="h-7 w-7 rounded-lg" /></div>;
}